import { Link } from "react-router-dom";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
       <div className="overlay"></div>

      <div className="hero-content">
      <span className="tag">NEVA MERMER</span>
        <h1>Taşın Zarafetini Yaşatıyoruz</h1>
        <p>Mermer, granit ve doğal taş uygulamalarında 15+ yıllık deneyim. Mutfak tezgahından merdiven kaplamaya, iç dekorasyondan mezar taşına kadar her işte kalite ve güven.</p>

        <div className="hero-buttons">
          <Link to="/taslar">Ücretsiz Keşif</Link>
          <Link to="/projeler">Projeleri Gör</Link>
        </div>
      </div>
    </section>
  );
}